import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { useMemo } from "react";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

// Export the client directly for use in Redux and other non-React code
export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

// Keep the hook for React components if needed
export const useSupabase = () => {
  const supabaseClient = useMemo(
    () => supabase,
    []
  );

  return { supabase: supabaseClient };
};